export default {
  ERROR_COMPONENT_CREATE: 'We experienced an error while creating a new component. Please try again.',
  ERROR_COMPONENT_DELETE: 'An error occurred deleting the component. Please try again',
  ERROR_COMPONENT_NOT_FOUND: 'We couldn\'t find the requested component. Please ensure you have entered the correct URL or ensure the component still exists.',
  ERROR_COMPONENT_SAVE: 'We experienced an error while saving your component. Please try again.',
  ERROR_UPLOAD_FILETYPE_RESTRICT: 'You can only upload JPEG, PNG and SVG files',
  ERROR_UPLOAD_MAX_FILELIMIT: 'You\'ve reached the maximum number of files that can be uploaded',
  ERROR_UPLOAD_MAX_FILESIZE: 'Each file must be smaller than 10MB',
  ERROR_UPLOAD_UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.',
  COMPONENT_DELETE_ASK: 'Are you sure you want to delete **%%**?',
  COMPONENT_DELETE_CONFIRM: 'Deleting **%%**',
} as {
  [key: string]: string,
};
